import requester from '@/utils/requester';

export interface IParamSuggestApi {
  key?: string;
  limit?: number;
  offset?: number;
  search?: string;
  source?: string;
}

const suggestApi = {
  async suggest({ ...rest }: IParamSuggestApi = {}) {
    return await requester.get(`/phr/v1/suggest`, {
      params: { limit: 10, offset: 0, ...rest },
    });
  },
  async getTags({ ...rest }: IParamSuggestApi = {}) {
    return await requester.get(`/phr/v1/suggest`, {
      params: { limit: 10, offset: 0, ...rest, key: 'tag' },
    });
  },
};

export default suggestApi;
